import React, { useState, useRef, useCallback } from "react";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { GoogleMap, Circle, Marker, useLoadScript } from "@react-google-maps/api";
import { RootState } from "@redux/store";
import { updateLocation } from "@redux/slices/filter";
import { Input } from "@components/ui/input";
import RadiusSliderComp from "@components/ui/sliderRadius";
import { Button } from "@components/ui/button";
import { ChevronLeft, X } from "lucide-react";
import { FilterAtom } from "@/App";
import {useRecoilState } from "recoil";

type LatLng = {
  lat: number;
  lng: number;
};

interface Props {
  handleClose: () => void;
}

const RadiusFilter: React.FC<Props> = ({ handleClose }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { location, radius } = useSelector(
    (state: RootState) => state.filter?.regionalFilters?.radius
  );

  const [localLocation, setLocalLocation] = useState(location || "Berlin");
  const [localRadius, setLocalRadius] = useState(radius || 1000);
  const [center, setCenter] = useState<LatLng>({ lat: 52.5068, lng: 13.4243 }); // Default to Berlin

  const mapRef = useRef<google.maps.Map | null>(null);

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyC4-ciLOxbOMktOwU8uTBmSTfhy6kDMpSo", // Replace with your API key
    libraries: ["places"], // Load the places library for search
  });

  const onLoad = useCallback((map: google.maps.Map) => {
    mapRef.current = map;
  }, []);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    setLocalLocation(input);

    if (!mapRef.current) return;

    const service = new window.google.maps.places.PlacesService(mapRef.current);
    const request: google.maps.places.FindPlaceFromQueryRequest = {
      query: input,
      fields: ["name", "geometry"],
    };

    service.findPlaceFromQuery(request, (results, status) => {
      if (status === window.google.maps.places.PlacesServiceStatus.OK && results && results[0].geometry?.location) {
        const newCenter = results[0].geometry.location.toJSON();
        setCenter(newCenter);
        mapRef.current?.panTo(newCenter);
      }
    });
  };

  const handleRadiusChange = (newValue: number) => {
    setLocalRadius(newValue);
    dispatch(updateLocation({ location: localLocation, radius: newValue }));
  };

  const handleRadiusInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = Number(e.target.value);
    if (!isNaN(value) && value > 0) {
      setLocalRadius(value);
      dispatch(updateLocation({ location: localLocation, radius: value }));
    }
  };

  const [filter, setFilter] = useRecoilState(FilterAtom);
  const handleClick = (id: string) => {
    console.log("now clicked is " + id);
    // setClickedIds((prevStrings) => [...prevStrings, id]);
    setFilter((prevFilters: string[]) => [...prevFilters, id]); // Append to the atom
    console.log("I am here now");
  };

  if (!isLoaded) return <div>Loading...</div>;

 

  return (
    <div className="flex flex-col justify-center items-center h-full w-full relative">
      <div className="absolute top-0 w-full h-full">
        <GoogleMap
          zoom={12}
          center={center}
          mapContainerClassName="w-full h-full"
          onLoad={onLoad}
        >
          <Marker position={center} />
          <Circle
            center={center}
            radius={localRadius * 1000} // Convert km to meters
            options={{
              fillColor: "#1CB5AF",
              fillOpacity: 0.2,
              strokeColor: "#1CB5AF",
            }}
          />
        </GoogleMap>
      </div>

      <div className="rounded-lg absolute top-10 left-0 w-[50%] p-8  z-10">
        <div className="flex justify-between items-center mb-5">
          <h4 className="text-xl font-bold flex items-center -ms-2">
            <ChevronLeft
              size={22}
              className="me-3 font-[10px] cursor-pointer"
              onClick={() => navigate(-1)}
            />
            Radius
          </h4>
          <X onClick={handleClose} className="cursor-pointer" />
        </div>

        <div className="bg-white rounded-lg w-full px-6 py-4">
         
        <p className="text-[black] mb-1 text-[23px]">Search Options</p>
          <p className="text-[#71717A] mb-1 text-sm">Enter Location</p>
          <Input
            placeholder="ZIP, city or company name"
            value={localLocation}
            onChange={handleSearch}
          />

          <div className="mt-4">
            <p className="text-[#71717A] mb-1 text-sm">Radius</p>
            <div className="flex gap-4 items-center">
            <p className="text-[#71717A] mb-1 text-sm">KM</p>
              <Input
                type="number"
                placeholder="Radius in km"
                value={localRadius.toString()}
                onChange={handleRadiusInputChange}
                className="w-1/3"
              />
            
            </div>
          </div>

          <div className="mt-4">
            <RadiusSliderComp
              value={localRadius}
              onChange={(_, newValue) => handleRadiusChange(newValue as number)}
            />
          </div>

          <div className="flex justify-end mt-6">
          <Button
            onClick={() => {
              handleClick("Radius");
              navigate(-1);
              dispatch(updateLocation({ location: localLocation, radius: localRadius }));
            }}
            className="bg-[#1CB5AF]"
          >
              

            Save
          </Button>
        </div>
        </div>

      
      </div>
    </div>
  );
};

export default RadiusFilter;
